import gql from "graphql-tag";

export const CREATE_CRM_SENDER = gql`
  mutation AddCrmSender($data: CrmSenderDataInput) {
    addCrmSender(data: $data) { id email }
  }
`;

export const UPDATE_CRM_SENDER = gql`
  mutation UpdateCrmSender($where: CrmSenderWhereInput, $data: CrmSenderDataInput) {
    updateCrmSender(where: $where, data: $data) { id }
  }
`;

export const DELETE_CRM_SENDER = gql`
  mutation DeleteCrmSender($where: CrmSenderWhereInput) {
    deleteCrmSender(where: $where) { id }
  }
`;

const crmSenders = { CREATE_CRM_SENDER, UPDATE_CRM_SENDER, DELETE_CRM_SENDER };
export default crmSenders;
